import React from 'react'

import { alpha, Box, Typography } from "@mui/material"
import { currencyCode } from "@signals"
import { AppRetailerBlock } from "@components"
import AnalyzerPopover from "Pages/AnalyzersV2/@components/Popover"
import { useCategoriesPopover } from "Pages/AnalyzersV2/@components/CategoriesTable/@hooks"
import { categoryCellEvidence } from "Pages/AnalyzersV2/@services/askEvidence"
import { analyzerAskContext } from "Pages/AnalyzersV2/@services/askScope"


// `rows` (CU-869fkdhjv phase 3): the table, so "Ask Iris" can say where the offer stands in its category
export default function priceColumn(label, rows = []) {

	return {
		name: label,
		render: (cell) => <RenderPriceColumn
			cell={cell}
			category={label}
			rows={rows}
			priceData={cell?.price_data}
			provider={cell?.id_master_provider_translation}
			providerIcon={cell?.ico}
			value={cell?.value}
			evolutionFilter={cell?.evolutionFilter}
			site={cell?.id_site_translation}
		/>,
	}
}


function RenderPriceColumn({ cell, category, rows, value, provider, providerIcon, priceData, evolutionFilter, site }) {

	const { isOpenPopover, onClosePopover, onOpenPopover } = useCategoriesPopover()
	const getAsk = () => {
		const ctx = analyzerAskContext({ currency: currencyCode.value })
		return categoryCellEvidence({
			section: ctx.section, category, cell, rows, currency: currencyCode.value,
			params: ctx.params, freshness: ctx.freshness, dsRepricing: ctx.dsRepricing,
		})
	}
	const askOrigin = { row: provider || site, car: category, date: priceData?.pickup_date, days: priceData?.length_of_rental, from: 'cell' }

	return <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
		<Box
			onClick={e => onOpenPopover(e.currentTarget)}
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				p: 1,
				border: "1px solid",
				borderRadius: "8px",
				borderColor: !!priceData?.color ? alpha(priceData?.color, 0.6) : "transparent",
				backgroundColor: !!priceData?.color ? alpha(priceData?.color, 0.1) : "transparent",
				transition: "border-color 0.15s ease",
				width: 140,
				height: 100,
				cursor: 'pointer',
				'&:hover': {
					borderColor: !!priceData?.color ? priceData?.color : "transparent",
				}
			}}>
			<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 1, flexDirection: "column" }}>
				<Typography variant="subtitle1">{!!value ? `${value} ${currencyCode.value}` : "N/A"}</Typography>
				<AppRetailerBlock retailer={provider || site} icon={providerIcon}/>
			</Box>
		</Box>
		<AnalyzerPopover isOpen={isOpenPopover} onClose={onClosePopover} data={{ evolutionFilter, price_data: priceData }}
			getAsk={!!value ? getAsk : null} askOrigin={askOrigin}/>
	</Box>
}